import { Link } from 'react-router-dom'
import clsx from 'clsx'

export type SideNavHeaderProps = {
  /** URL for the logo image */
  logoUrl: string
  /** Alt text for the logo */
  logoAlt?: string
  /** Where clicking the logo navigates to */
  logoHref?: string
  /** Whether to apply fixed height sizing to the logo (34px) */
  hasFixedLogoHeight?: boolean
  /** Optional callback when logo is clicked (e.g., to close mobile sidebar) */
  onLogoClick?: () => void
}

/**
 * Header section of the SideNav containing the logo.
 *
 * Features:
 * - Logo with link to dashboard
 * - Border styling with visual gap on the right
 * - Fixed 60px height
 */
export function SideNavHeader({ logoUrl, logoAlt = 'Logo', logoHref = '/dashboard', hasFixedLogoHeight = false, onLogoClick }: SideNavHeaderProps) {
  return (
    <div className="flex relative h-[60px]">
      <div className="w-full flex items-center justify-start pl-6">
        <Link to={logoHref} onClick={onLogoClick}>
          <img className={clsx('max-w-[150px] max-h-[56px] mx-auto', hasFixedLogoHeight && 'h-[34px] w-auto')} src={logoUrl} alt={logoAlt} />
        </Link>
      </div>
      {/* Narrow div creating a vertical border-right with a gap below */}
      <div className="w-4 mb-4 border-r" />
      {/* Bottom border line at y=60 with gap on right */}
      <div className="absolute bottom-0 left-0 right-4 border-b border-brand-neutral-200" />
    </div>
  )
}
